import { render } from "./Fields.vue?vue&type=template&id=531882fe"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/rules/Fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "531882fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('531882fe', __exports__)) {
    api.reload('531882fe', __exports__)
  }
  
  module.hot.accept("./Fields.vue?vue&type=template&id=531882fe", () => {
    api.rerender('531882fe', render)
  })

}


export default __exports__